import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthGuard } from '../../core/guard/auth.guard';
import { BreadcrumbService } from '../../core/service/breadcrumb.service';

@Component({
  selector: 'app-form-success',
  templateUrl: './form-success.component.html',
  styleUrl: './form-success.component.css'
})
export class FormSuccessComponent implements OnInit, AfterViewInit {
  accidentId:number=0;
  isFormSuccess:boolean=false;
  constructor(private route:Router,private authGuard:AuthGuard, private breadcrumbService: BreadcrumbService,) {}

   ngOnInit(): void {
    this.accidentId=this.breadcrumbService.getAccidentID();
    this.isFormSuccess=this.breadcrumbService.getFormIsSubmitted();
    
    this.breadcrumbService.sideNav$.subscribe((value) => {
      console.log(value,'line no 17');
      if (value) {
        this.breadcrumbService.closeSideNav();
      }
    });
   }

   ngAfterViewInit(){
    this.breadcrumbService.sideNav$.subscribe((value) => {
      console.log(value,'line no 18');
      if (value) {
        this.breadcrumbService.closeSideNav();
      }
    });
    
   }
  logout() {
    this.authGuard.authenticateUser(0);
    this.route.navigate(['/login']);
    this.breadcrumbService.setActiveStep(0);
  }

  reportAnotherAccident(){
    this.route.navigate(['/report']);
    this.breadcrumbService.showBreadCrumbsComponent();
    this.breadcrumbService.setActiveStep(0);
  }
}
